<template>
    <div class="fillBgBox" @click="onClickBannerImg">
        <img class="bg" :src="bgImg" alt="">
        <div class="FBBox_content">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: "fillBgBox",
        props: {
            bgImg: {
                type: String,
                require: true
            },
            imgData: {
                type: Object,
            }
        },
        data() {
            return {}
        },
        mounted() {

        },
        methods: {
            onClickBannerImg() {
                window.open(this.imgData.jumpUrl, '_blank');
            }
        }
    }
</script>

<style scoped lang="less">
    .fillBgBox {
        width: 100%;
        background-size: 100% auto;
        background-repeat: no-repeat;
        position: relative;

        .bg {
            width: 100%;
            display: block;
        }

        .FBBox_content {
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            width: 100%;
            height: 100%;
        }
    }
</style>
